/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
	applyFilters,
	addFilter
} from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	Fragment,
	useEffect,
	useRef,
} from '@wordpress/element'
import $ from 'jquery'
import {
	i18n,
	srcUrl
} from 'cartzillagb'
import {
	PanelBody,
	ToggleControl,
	RangeControl,
	SelectControl
} from '@wordpress/components'
import {
	RichText,
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'


/**
 * External dependencies
 */
import {
	BackgroundSettings,
	URLInputControl
} from '~cartzillagb/components'
import { withTabbedInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'

import PlaceholderImage  from  './img/ph-img.jpg'

addFilter( 'cartzillagb.hero-carousel-3.edit.inspector.style.before', 'czgb/hero-carousel-3', ( output, props ) => {
	const { 
		attributes,
		setAttributes,
		clientId,
	} = props

	const {
		blockId,
		limit,
		autoplay,
		speed,
		autoplaySpeed
	} = props.attributes

	const slideLimitUpdate = limit => {
		if ( $( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		} else if ( $( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		}

		setAttributes( { limit } )
	}

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<RangeControl
					label={ __( 'No Of Slides', i18n ) }
					value={ limit }
					onChange={ limit => { slideLimitUpdate( limit ) } }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.max.limit', 5 ) }
				/>
				<ToggleControl
					label={ __( 'Enable Autoplay?', i18n ) }
					checked={ autoplay }
					onChange={ autoplay => setAttributes( { autoplay } ) }
				/>
				{ autoplay && 
					<Fragment>
						<RangeControl
							label={ __( 'Transition Speed', i18n ) }
							value={ speed }
							onChange={ speed => setAttributes( { speed } ) }
							min={ 1000 }
							step={ 500 }
							max={ applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.speed.limit', 6000 ) }
						/>
						<RangeControl
							label={ __( 'Autoplay Speed', i18n ) }
							value={ autoplaySpeed }
							onChange={ autoplaySpeed => setAttributes( { autoplaySpeed } ) }
							min={ 1000 }
							step={ 500 }
							max={ applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.autoSpeed.limit', 6000 ) }
						/>
					</Fragment>
				}
			</PanelBody>
			<Fragment>
				{ range( 1, limit + 1 ).map( i => {
				const bgColor = attributes[ `bgcolor${ i }` ]
				const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
				const enableTitle = attributes[ `enableTitle${ i }` ]
				const enablesubTitle = attributes[ `enablesubTitle${ i }` ]
				const enablebuttonTitle = attributes[ `enablebuttonTitle${ i }` ]
				const enableButton = attributes[ `enableButton${ i }` ]

				const btnlimit = attributes[ `btnlimit${ i }` ]

				const defaultBackgroundImage = `${ srcUrl }/${ PlaceholderImage }`

				return (
					<Fragment key={ i }>
						<PanelBody title={ __( 'Slide Settings #', i18n ) + i } initialOpen={ i === 1 ? true : false } key={ i }>
							<BackgroundSettings
								backgroundImageURL={ attributes[`mediaURL${ i }`] !== undefined ? attributes[`mediaURL${ i }`] : defaultBackgroundImage }
								onChangeBackgroundImage={ ( { url } ) => setAttributes( { [`mediaURL${ i }`]: url } ) }
								onRemoveBackgroundImage={ () => { setAttributes( { [`mediaURL${ i }`]: '' } ) } }
							/>

							<BackgroundSettings 
								background={ bgColor !== undefined ? bgColor : ' bg-primary' }
								backgroundColor={ bgcustomColor }
								onChangeBackground={ bgColor => setAttributes( { [ `bgcolor${ i }` ]: ` ${ bgColor }`, [ `bgcustomcolor${ i }` ]: '' } ) }
								onChangeBackgroundColor={ bgcustomColor => setAttributes( { [ `bgcustomcolor${ i }` ]: bgcustomColor.hex, [ `bgcolor${ i }` ]: '' } ) }
								onRemoveBackground={ () => { setAttributes( { [ `bgcolor${ i }` ]: '', [ `bgcustomcolor${ i }` ]: '' } ) } }
							/>

							<ToggleControl
								label={ __( 'Display Title', i18n ) }
								checked={ enableTitle }
								onChange={ enableTitle => setAttributes( { [ `enableTitle${ i }` ]: enableTitle } ) }
							/>

							<ToggleControl
								label={ __( 'Display Subtitle', i18n ) }
								checked={ enablesubTitle }
								onChange={ enablesubTitle => setAttributes( { [ `enablesubTitle${ i }` ]: enablesubTitle } ) }
							/>

							<ToggleControl
								label={ __( 'Display Button Text', i18n ) }
								checked={ enablebuttonTitle }
								onChange={ enablebuttonTitle => setAttributes( { [ `enablebuttonTitle${ i }` ]: enablebuttonTitle } ) }
							/>

							<ToggleControl
								label={ __( 'Display Button ?', i18n ) }
								checked={ enableButton }
								onChange={ enableButton => setAttributes( { [ `enableButton${ i }` ]: enableButton } ) }
							/>
						</PanelBody>
						{ enableButton &&
							<PanelBody title={ __( 'Button Settings Slide #', i18n ) + i }>
								<RangeControl
									initialOpen={ false }
									label={ __( 'Number of Buttons', i18n ) }
									value={ btnlimit }
									onChange={ btnlimit => setAttributes( {  [ `btnlimit${ i }` ] : btnlimit } ) }
									min={ 1 }
									max={ applyFilters( 'cartzillagb.market-button.btnlimit.edit.inspector.max.btnlimit', 4 ) }
								/>
								{ range( 1, btnlimit + 1 ).map( j => {
									const btnbgColor = attributes[ `btnbgcolor${ i }${ j }` ]
									const btnbgcustomColor = attributes[ `btnbgcustomcolor${ i }${ j }` ]
									const btnicon = attributes[ `btnicon${ i }${ j }` ] !== undefined ? attributes[ `btnicon${ i }${ j }` ] : j === 1 ? 'btn-apple' : 'btn-google'
									const btnlink = attributes[ `btnlink${ i }${ j }` ] !== undefined ? attributes[ `btnlink${ i }${ j }` ]  : '#'

									return (
										<Fragment key={ i }>
											<SelectControl
												label={ __( 'Icon' ) }
												values={ btnicon }
												options={ [
													{ label: __('None', 'cartzilla', i18n ), value: 'none' },
													{ label: __('Apple', 'cartzilla', i18n ), value: 'btn-apple' },
													{ label: __('Google', 'cartzilla', i18n ), value: 'btn-google' },
													{ label: __('Windows', 'cartzilla', i18n ), value: 'btn-windows' },
													{ label: __('Amazon', 'cartzilla', i18n ), value: 'btn-amazon' },
												] }
												onChange={ btnicon => setAttributes( {  [ `btnicon${ i }${ j }` ] : btnicon } ) }
											/>
											<BackgroundSettings
												background={ btnbgColor !== undefined ? btnbgColor : 'bg-primary' }
												backgroundColor={ btnbgcustomColor }
												onChangeBackground={ btnbgColor => setAttributes( { [ `btnbgcolor${ i }${ j }` ]: btnbgColor, [ `btnbgcustomcolor${ i }${ j }` ]: '' } ) }
												onChangeBackgroundColor={ btnbgcustomColor => setAttributes( { [ `btnbgcustomcolor${ i }${ j }` ]: btnbgcustomColor.hex, [ `bgcolor${ i }${ j }` ]: '' } ) }
												onRemoveBackground={ () => { setAttributes( { [ `btnbgcolor${ i }${ j }` ]: '', [ `btnbgcustomcolor${ i }${ j }` ]: '' } ) } }
											/>
											<URLInputControl
												value={ btnlink }
												onChange={ btnlink => setAttributes( { [ `btnlink${ i }${ j }` ]: btnlink } ) }
											/>
										</Fragment>
									)
								} ) }
							</PanelBody>
						}
					</Fragment>
				)
			} ) }
			</Fragment>			
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes, 
		className,
		clientId,
	} = props 

	const {
		blockId,
		limit,
		autoplay,
		speed,
		autoplaySpeed
	} = attributes

	const slickEl = useRef(clientId)
	const setBlockId = blockId => setAttributes({ blockId })

	if ( clientId !== blockId ) {
		setBlockId( clientId )
	}

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				slidesToShow: limit,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true );
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' );
		}
	}, [limit] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				autoplay: attributes.autoplay,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true );
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' );
		}
	}, [autoplay] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				autoplaySpeed: attributes.autoplaySpeed,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true );
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' );
		}
	}, [autoplaySpeed] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				speed: attributes.speed,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true );
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' );
		}
	}, [speed] )
	
	

	const mainClasses = classnames( [
		'cz-carousel',
		'mb-4',
		'mb-sm-5',
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const content = range( 1, limit + 1 ).map( i => {

		const Title = attributes[ `title${ i }` ]
		const subTitle = attributes[ `subtitle${ i }` ]
		const ButtonTitle = attributes[ `buttontitle${ i }` ]
		const MediaURL = attributes[ `mediaURL${ i }` ]
		const bgColor = attributes[ `bgcolor${ i }` ]
		const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
		const enableTitle = attributes[ `enableTitle${ i }` ]
		const enablesubTitle = attributes[ `enablesubTitle${ i }` ]
		const enablebuttonTitle = attributes[ `enablebuttonTitle${ i }` ]
		const btnlimit = attributes[ `btnlimit${ i }` ]
		const enableButton = attributes[ `enableButton${ i }` ]

		let defaultTitle = ''
		let defaultSubtitle = ''
		let defaultButtonTitle = ''
		let defaultbgColor = ''
		const defaultImg = `${ srcUrl }/${ PlaceholderImage }`

		if ( i % 5 === 1 ) {
			defaultTitle = 'Fresh Foods a Click Away'
			defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
			defaultButtonTitle = 'On the go? Try our mobile app'
			defaultbgColor = '#59c879'
		}
		if ( i % 5 === 2 ) {
			defaultTitle = '24/7 Delivery Service'
			defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
			defaultButtonTitle = 'On the go? Try our mobile app'
			defaultbgColor = '#1a6fb0'
		}
		if ( i % 5 === 3 ) {
			defaultTitle = 'Fresh Foods a Click Away'
			defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
			defaultButtonTitle = 'On the go? Try our mobile app'
			defaultbgColor = '#59c879'
		}
		if ( i % 5 === 4 ) {
			defaultTitle = '24/7 Delivery Service'
			defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
			defaultButtonTitle = 'On the go? Try our mobile app'
			defaultbgColor = '#1a6fb0'
		}
		if ( i % 5 === 0 ) {
			defaultTitle = 'Fresh Foods a Click Away'
			defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
			defaultButtonTitle = 'On the go? Try our mobile app'
			defaultbgColor = '#59c879'
		}

		const bgstyle = { backgroundColor: bgcustomColor !== undefined ? bgcustomColor : defaultbgColor }

		const titleComp = enableTitle && (
			<RichText
				tagName="h2"
				className={ `h1 text-light` } 
				value={ Title || defaultTitle }
				onChange={ Title => setAttributes( { [ `title${ i }` ]: Title } ) }
				placeholder={ __( 'Title', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const subtitleComp = enablesubTitle &&  (
			<RichText
				tagName="p"
				value={ subTitle || defaultSubtitle }
				className={ `text-light pb-4` }
				onChange={ subTitle => setAttributes( { [ `subtitle${ i }` ]: subTitle } ) }
				placeholder={ __( 'subtitle', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const buttontitleComp = enablebuttonTitle && (
			<RichText
				tagName="h5"
				className={ `text-light pb-3 text-light` } 
				value={ ButtonTitle || defaultButtonTitle }
				onChange={ ButtonTitle => setAttributes( { [ `buttontitle${ i }` ]: ButtonTitle } ) }
				placeholder={ __( 'ButtonTitle', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const btncontent = range( 1, ( btnlimit ) + 1 ).map( j => {
			const btnPreTitle = attributes[ `btnpretitle${ i }${ j }` ]
			const btnTitle = attributes[ `btntitle${ i }${ j }` ]
			const btnbgColor = attributes[ `btnbgcolor${ i }${ j }` ]
			const btnbgcustomColor = attributes[ `btnbgcustomcolor${ i }${ j }` ]
			const btnicon = attributes[ `btnicon${ i }${ j }` ]
			const btnlink = attributes[ `btnlink${ i }${ j }` ] !== undefined ? attributes[ `btnlink${ i }${ j }` ]  : '#'

			let defaultbtntitle = ''
			let defaultbtnpretitle = ''
			let defaultbtnIcon = ''

			if ( (j % 4 ) === 1 ) {
				defaultbtnpretitle = "Download on the"
				defaultbtntitle = "App Store"
				defaultbtnIcon = 'btn-apple'
			}

			if ( (j % 4 ) === 2 ) {
				defaultbtnpretitle = "Download on the"
				defaultbtntitle = "Google Play"
				defaultbtnIcon = 'btn-google'
			}

			if ( (j % 4 ) === 3 ) {
				defaultbtnpretitle = "Download on the"
				defaultbtntitle = "Windows Store"
				defaultbtnIcon = 'btn-windows'
			}

			if ( (j % 4 ) === 0 ) { 
				defaultbtnpretitle = "Download on the"
				defaultbtntitle = "Amazon.com"
				defaultbtnIcon = 'btn-amazon'
			}

			const btnbgstyle = { backgroundColor: btnbgcustomColor && btnbgcustomColor }

			const btniconClass = classnames( [
				btnicon === 'none' && '',
				btnicon === 'btn-apple' && ' btn-apple',
				btnicon === 'btn-google' && ' btn-google',
				btnicon === 'btn-windows' && ' btn-windows',
				btnicon === 'btn-amazon' && ' btn-amazon'
			] )

			const btnpretitleComp =(
				<RichText
					tagName="span"
					className="btn-market-subtitle"
					value={ btnPreTitle || defaultbtnpretitle }
					onChange={ btnPreTitle => setAttributes( { [ `btnpretitle${ i }${ j }` ]: btnPreTitle } ) }
					placeholder={ __( 'BtnPreTitle', i18n ) }
					keepPlaceholderOnFocus
				/>
			)

			const btntitleComp =(
				<RichText
					tagName="span"
					className="btn-market-title"
					value={ btnTitle || defaultbtntitle }
					onChange={ btnTitle => setAttributes( { [ `btntitle${ i }${ j }` ]: btnTitle } ) }
					placeholder={ __( 'BtnTitle', i18n ) }
					keepPlaceholderOnFocus
				/>
			)

			const output = (
				<Fragment key={ `${ i }-${ j }` }>
					<button className={ `btn-market ${ btniconClass || defaultbtnIcon } mr-2 mb-2 ${ btnbgColor ? btnbgColor : btnbgcustomColor ? '' : '' }` } style={ btnbgstyle } href={ btnlink } role="button" key={ `${ i }-${ j }` }>
						{ btnpretitleComp }
						{ btntitleComp }
					</button>
				</Fragment>
			)

			return output
		} )

		const output = (
			<div className={ `slider` } key={ i }>
				<div className={ `rounded-lg px-md-5 text-center text-xl-left bg-color ${ bgColor }` } style={ bgstyle }>
					<div className="d-xl-flex justify-content-between align-items-center px-4 px-sm-5 mx-auto slider-inner">
						<div className="py-5 mr-xl-4 mx-auto mx-xl-0 slider-content">
							{ titleComp }
							{ subtitleComp }
							{ buttontitleComp }
							{ enableButton && btncontent }
						</div>
						<div>
							<img src={ MediaURL ? MediaURL : defaultImg } alt="Image" />
						</div>
					</div>
				</div>
			</div>
		)

		return output
	} )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-3.main-block.classes', {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots : false,
		arrows : true,
		adaptiveHeight : true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		speed: speed,
		autoplaySpeed: autoplaySpeed,
		autoplay: autoplay,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 0,
				settings: {
					nav: true,
					controls: false
				}
			},
			{
				breakpoint: 576,
				settings: {
					nav: false,
					controls: true
				}
			},
		],
	}, props )

	let carouselOptions = {
		fade: true,
		mode: "gallery"

	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	return (
		<div ref={ slickEl } id={ blockId || clientId } className={ mainClasses }>
			<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
				{ content }
			</div>
		</div>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )
